import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getDensityModeString } from 'owa-fabric-theme';

export interface AttachmentDocInfoBaseProps {
    firstLineTitle?: string;
    firstLineText: string;
    secondLineTitle?: string;
    secondLineText?: string;
    firstLineStyle?: string;
    secondLineStyle?: string;
    isShortDocView: boolean;
    highlightAttachmentName?: (ref: HTMLDivElement) => void;
}

import styles from './AttachmentDocInfoViewBase.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);
const hasDensityNext = isFeatureEnabled('mon-densities');
const densityModeString = getDensityModeString();

const AttachmentDocInfoViewBase = observer(function AttachmentDocInfoViewBase(
    props: AttachmentDocInfoBaseProps
) {
    const {
        firstLineTitle,
        firstLineText,
        secondLineTitle,
        secondLineText,
        highlightAttachmentName,
    } = props;
    if (props.isShortDocView) {
        return (
            <div
                className={classNames(
                    hasDensityNext ? styles.firstLineCommonStyleNext : styles.firstLineCommonStyle,
                    hasDensityNext && densityModeString,
                    props.firstLineStyle,
                    styles.textOverFlow
                )}
                title={firstLineTitle}
                ref={highlightAttachmentName}>
                {firstLineText}
            </div>
        );
    }

    return (
        <>
            <div
                className={classNames(
                    hasDensityNext ? styles.firstLineCommonStyleNext : styles.firstLineCommonStyle,
                    hasDensityNext && densityModeString,
                    props.firstLineStyle,
                    styles.textOverFlow
                )}
                title={firstLineTitle}>
                {firstLineText}
            </div>
            <div
                title={secondLineTitle}
                className={classNames(
                    styles.secondLineCommonStyle,
                    props.secondLineStyle,
                    styles.textOverFlow
                )}>
                {secondLineText}
            </div>
        </>
    );
});
export default AttachmentDocInfoViewBase;
